// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1FU2F","name":"Header_name__YmYed","birthday":"Header_birthday__kg5rD","skeleton":"Header_skeleton__3LLwS"};